import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { y18nPlugin } from "./utils/i18n";
import { getOssImageUrl } from "./config/image";
import lazyDirective from "./directives/lazy";

import "./assets/custom.scss";

const app = createApp(App);

app.config.globalProperties.$ossImg = getOssImageUrl;
app.directive("lazy", lazyDirective);

app.use(router);
app.use(y18nPlugin);

app.mount("#app");
